<template>
  <div
    :style="size"
    class="public-code"
    @click="clickRetry"
  >
    <div class="app-wrap">
      <div class="app-fail">
        <span class="fail-mark" /> <span class="app-code-icon">
          <svg
            aria-hidden="true"
            class="icon huanyipi"
          >
            <use xlink:href="#huanyipi">
              <svg
                id="huanyipi"
                viewBox="0 0 1024 1024"
              ><path d="M729.6 294.4c-6.4-6.4-10.666667-17.066667-10.666667-27.733333 0-21.333333 17.066667-38.4 38.4-38.4h100.266667c21.333333 0 38.4 17.066667 38.4 38.4s-17.066667 38.4-38.4 38.4h-21.333333C874.666667 364.8 896 435.2 896 512c0 213.333333-172.8 384-384 384-21.333333 0-38.4-17.066667-38.4-38.4s17.066667-38.4 38.4-38.4c170.666667 0 307.2-138.666667 307.2-307.2 0-83.2-32-160-89.6-217.6zM294.4 729.6c6.4 6.4 10.666667 17.066667 10.666667 27.733333 0 21.333333-17.066667 38.4-38.4 38.4H166.4c-21.333333 0-38.4-17.066667-38.4-38.4s17.066667-38.4 38.4-38.4h21.333333C149.333333 659.2 128 588.8 128 512 128 298.666667 300.8 128 512 128c21.333333 0 38.4 17.066667 38.4 38.4S533.333333 204.8 512 204.8C341.333333 204.8 204.8 343.466667 204.8 512c0 83.2 32 160 89.6 217.6z" /></svg>
            </use>
          </svg>
        </span><span class="app-title">二维码失效 点击重试</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrRetry',

  props: {
    size: {
      type: Object,
      default: () => ({
        width: '150px',
        height: '150px'
      })
    }
  },

  methods: {
    clickRetry () {
      this.$emit('emitClickRetry')
    }
  }
}
</script>

<style lang="scss" scoped>
  .public-code{
    margin: 0 auto;
    cursor: pointer;
    .icon {
      width: 1em;
      height: 1em;
      vertical-align: -.15em;
      fill: currentColor;
      overflow: hidden;
    }
    .app-wrap {
      position: relative;
      border: 1px solid #e2e2e2;
      width: 100%;
      height: 100%;
     .app-fail {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
       .app-title {
         position: absolute;
         display: block;
         width: 100%;
         bottom: 19px;
         text-align: center;
         font-size: 14px;
         color: #fff;
         z-index: 10;
         cursor: pointer;
       }
       .fail-mark {
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         background-color: rgba(51, 51, 51,.8);
         font-size: 14px;
         color: #fff;
       }
       .app-code-icon {
         display: inline-block;
         position: absolute;
         z-index: 10;
         left: 50%;
         top: 50%;
         transform: translateX(-50%) translateY(-70%);
         cursor: pointer;
         .huanyipi {
           font-size: 60px;
           color: #fff;
         }
       }
      }
    }
  }

</style>
